import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import swal from "sweetalert";

export default function StoreBackup() {
  const [busy, setBusy] = useState("");
  const fileRef = useRef(null);

  useEffect(() => {
    document.title = "Backup — Admin";
  }, []);

  const download = () => {
    setBusy("download");
    axios
      .get("/api/admin/store-backup", { responseType: "blob" })
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/zip" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const day = new Date().toISOString().slice(0, 10);
        link.href = url;
        link.download = `store-backup-${day}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        swal("Could not download", err.response?.data?.message || "Try again.", "error");
      })
      .finally(() => setBusy(""));
  };

  const cloneFile = (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) return;
    swal({
      title: "Clone this backup?",
      text: "This adds every record in the backup that is not already in this store, including orders, customers, and accounts. Records already here are kept.",
      icon: "warning",
      buttons: ["Cancel", "Clone backup"],
    }).then((yes) => {
      if (!yes) return;
      const data = new FormData();
      data.append("file", file);
      setBusy("clone");
      axios
        .post("/api/admin/store-backup/clone", data)
        .then((res) => {
          swal("Backup cloned", res.data.message || "The copies were added.", "success");
        })
        .catch((err) => {
          swal("Could not clone", err.response?.data?.message || "Choose a backup file from this store.", "error");
        })
        .finally(() => setBusy(""));
    });
  };

  return (
    <div className="container-fluid py-3">
      <div className="admin-card bg-white rounded-3 shadow-sm border mb-4">
        <div className="p-4 border-bottom">
          <h4 className="mb-1">Backup</h4>
          <p className="text-muted mb-0">
            Download the whole store, or clone a backup back into this store.
          </p>
        </div>
        <div className="p-4 d-flex flex-column gap-3">
          <p className="mb-0">
            The file contains the catalog, themes, store settings, customers, orders, payments, accounts,
            and the photos in the uploads folder. Sign-in sessions are left out. Cloning adds records
            that are not already here and keeps the records this store already has.
          </p>
          <div className="d-flex flex-wrap gap-2">
            <button type="button" className="btn btn-dark" onClick={download} disabled={busy !== ""}>
              {busy === "download" ? "Preparing…" : "Download backup"}
            </button>
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={() => fileRef.current && fileRef.current.click()}
              disabled={busy !== ""}
            >
              {busy === "clone" ? "Cloning…" : "Clone backup"}
            </button>
            <input ref={fileRef} type="file" accept=".zip,application/zip,.json,application/json" hidden onChange={cloneFile} />
          </div>
        </div>
      </div>
    </div>
  );
}
